import Api from './GraasApiUtility.api';
import { isEmpty as _isEmpty, omitBy as _omitBy } from 'lodash-es';
import QueryString from 'query-string';
import Cookies from 'js-cookie';
import { getIsDemoHost } from 'utilities/demo_utilities';

const GraasAPI = new Api();

// ----- GET API data
export const getDataFromApiAction = async (url = '', payload) => {
  let apiData = {};
  let fetchUrl = url;

  // --- check url is empty
  if (_isEmpty(url)) return;

  // --- check payload is not empty then build url query string
  if (!_isEmpty(payload)) {
    const omittedPayload = _omitBy(payload, _isEmpty);
    const queryObj = QueryString.stringify(omittedPayload) || '';
    fetchUrl = `${url}?${queryObj}`;
  }

  try {
    apiData = await GraasAPI.getDataFromApi(fetchUrl);
    if (apiData && apiData.hasError) {
      throw apiData;
    } else {
      const { data } = apiData;
      // faro.api.pushLog([`API is  ${fetchUrl}`], {
      //   level: LogLevel.WARN
      // });
      return data;
    }
  } catch (error) {
    return error;
  }
};

// ----- POST API data
export const postDataFromApiAction = async (url = '', payload) => {
  let apiData = {};

  // --- check url is empty
  if (_isEmpty(url)) return;

  try {
    apiData = await GraasAPI.postDataFromApiAction(url, payload);
    if (apiData && apiData.hasError) {
      throw apiData;
    } else {
      const { data } = apiData;
      return data;
    }
  } catch (error) {
    return error;
  }
};

// ----- PUT API data
export const updateDataFromApiAction = async (url = '', payload) => {
  let apiData = {};

  // --- check url is empty
  if (_isEmpty(url)) return;

  try {
    apiData = await GraasAPI.updateDataFromApiAction(url, payload);
    if (apiData && apiData.hasError) {
      throw apiData;
    } else {
      const { data } = apiData;
      return data;
    }
  } catch (error) {
    return error;
  }
};

// ----- PATCH API data
export const updatePartialDataFromApiAction = async (url = '', payload) => {
  let apiData = {};

  // --- check url is empty
  if (_isEmpty(url)) return;

  try {
    apiData = await GraasAPI.updatePartialDataFromApiAction(url, payload);
    if (apiData && apiData.hasError) {
      throw apiData;
    } else {
      const { data } = apiData;
      return data;
    }
  } catch (error) {
    return error;
  }
};

// ----- DELTE API data
export const deleteDataFromApiAction = async (url = '', payload = {}) => {
  let apiData = {};

  // --- check url is empty
  if (_isEmpty(url)) return;

  try {
    apiData = await GraasAPI.deleteDataFromApiAction(url, payload);
    if (apiData && apiData.hasError) {
      throw apiData;
    } else {
      const { data } = apiData;
      return data;
    }
  } catch (error) {
    return error;
  }
};
//to upload form data
export const fetchApiToPostFiles = async (url, payload, headers) => {
  headers.authorization = 'Bearer ' + Cookies.get('accessToken');
  headers.authtype = 'graas';
  const isDemoHost = getIsDemoHost();
  if(isDemoHost) {
    headers.countryCode = Cookies.get('countryCode');
  }
  return await fetch(url, {
    method: 'POST',
    headers: {
      ...headers
    },
    body: payload
  }).then(res => res.json());
};

export const fetchApiToDeleteData = async (url, payload, headers, callBackFunc) => {
  try {
    headers.authorization = 'Bearer ' + Cookies.get('accessToken');
    headers.authtype = 'graas';
    headers['Content-Type'] = 'application/json; charset=UTF-8';
    const isDemoHost = getIsDemoHost();
    if (isDemoHost) {
      headers.countryCode = Cookies.get('countryCode');
    }
    fetch(url, {
      method: 'DELETE',
      headers: {
        ...headers
      },
      body: JSON.stringify(payload) // Serialize your data as a JSON string
    })
      .then(res => {
        if (res.ok) {
          callBackFunc({
            hasError: false,
            error: ''
          });
        } else {
          callBackFunc({
            hasError: true,
            error: 'Failed'
          });
        }
      })
      .catch(error => {
        callBackFunc({
          hasError: true,
          error: 'Failed'
        });
      });
  } catch (error) {
    callBackFunc({
      hasError: true,
      error: 'Failed'
    });
  }
};

// ----- PATCH API call
export const patchUpdateFromApiAction = async (url = '', payload) => {
  let apiData = {};

  // --- check url is empty
  if (_isEmpty(url)) return;

  try {
    apiData = await GraasAPI.patchDataUpdateFromAPiAction(url, payload);
    if (apiData && apiData.hasError) {
      throw apiData;
    } else {
      const { data } = apiData;
      return data;
    }
  } catch (error) {
    return error;
  }
};
